export default __webpack_public_path__ + "assets/images/f3c9dd382864e1b3c6975626a8b40495.jpg";